<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
</script>

<template>
  <div class="jwx-pro-forecast__message-block jwx-pro-forecast__out-of-season-block">
    <p class="jwx-pro-forecast__message-title" data-size="large">{{ t('containers.proForecast.notAvailableNow') }}</p>
    <p class="jwx-pro-forecast__message-body" data-size="large">{{ t('common.tryAgainLater') }}</p>
  </div>
</template>